const formatLang = (locale) => {
    return (locale === null || locale === void 0 ? void 0 : locale.includes('fr')) ? 'fr' : 'en';
};
export default formatLang;
